<template>
  <div class="email-preferences">
    <div class="title">{{ $t('emailsConfiguration') }}</div>
    <div class="switch-btn" :class="{ selected: alertFrequency }">
      <div class="switch" @click="updateEmailPreferences(0)"></div>
      {{ $t('emailsActivation') }}
    </div>
    <div v-if="alertFrequency" class="frequency">
      <div class="label">{{ $t('emailsFrequency') }}</div>
      <div class="radio-button" :class="{ selected: alertFrequency === 1 }" @click="updateEmailPreferences(1)">
        <div class="radio"></div>
        {{ $t('everyDays') }}
      </div>
      <div class="radio-button" :class="{ selected: alertFrequency === 2 }" @click="updateEmailPreferences(2)">
        <div class="radio"></div>
        {{ $t('onceAWeek') }}
      </div>
      <div class="checkbox-input" @click="mainUserShouldReceiveAlerts = !mainUserShouldReceiveAlerts">
        <div class="checkbox" :class="{ checked: mainUserShouldReceiveAlerts }"></div>
        <div class="checkbox-label">
          {{ $t('mainUserShouldReceiveAlerts') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    company: {
      type: Object,
    },

    clientCreation: {
      type: Boolean,
    },

    value: {
      type: Object,
    },
  },

  data() {
    return {
      alertFrequency: 1,
      mainUserShouldReceiveAlerts: true,
    };
  },

  watch: {
    company(company) {
      if (company) {
        this.alertFrequency = company.alertFrequency;
      }
    },

    alertFrequency() {
      if (this.clientCreation) {
        this.$emit('input', {
          alertFrequency: this.alertFrequency,
          mainUserShouldReceiveAlerts: this.mainUserShouldReceiveAlerts,
        });
      }
    },

    mainUserShouldReceiveAlerts() {
      if (this.clientCreation) {
        this.$emit('input', {
          alertFrequency: this.alertFrequency,
          mainUserShouldReceiveAlerts: this.mainUserShouldReceiveAlerts,
        });
      }
    },
  },

  mounted() {
    this.alertFrequency = this.company ? this.company.alertFrequency : this.value?.alertFrequency;
    this.mainUserShouldReceiveAlerts = this.company ? this.company.mainUserShouldReceiveAlerts : this.value?.mainUserShouldReceiveAlerts;
  },

  methods: {
    updateEmailPreferences(frequencyDays) {
      if (!this.alertFrequency && !frequencyDays) {
        this.alertFrequency = 1;
      } else {
        this.alertFrequency = frequencyDays;
      }
      if (!this.clientCreation) {
        this.$store.dispatch('editClient', {
          id: this.company.id,
          alertFrequency: this.alertFrequency,
          mainUserShouldReceiveAlerts: this.mainUserShouldReceiveAlerts,
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
@use '@/styles/colors.scss';
@use '@/styles/responsive.scss';
@use '@/styles/fonts.scss';
.email-preferences {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 40px;
}

.title {
  color: colors.$darkblue-color;
  font-weight: 500;
  font-size: 20px;
  margin-bottom: 24px;
  width: 100%;
}

.label {
  width: 100%;
  font-weight: 600;
  margin-bottom: 12px;
}

.frequency {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
}

.switch-btn {
  display: flex;
  align-items: center;
  cursor: pointer;
  margin-bottom: 24px;

  .switch {
    width: 48px;
    height: 24px;
    border-radius: 12px;
    border: 1px solid colors.$lightgrey-color;
    background: colors.$white-color;
    margin-right: 10px;
    display: flex;
    align-items: center;
    flex-shrink: 0;
    transition: 0.3s linear;

    &::after {
      content: '';
      position: relative;
      left: 24px;
      background: colors.$lightgrey-color;
      width: 20px;
      height: 20px;
      border-radius: 50%;
      transition: 0.3s ease-out;
    }
  }

  &:hover,
  &:focus {
    outline: none;

    .switch {
      outline: none;
      box-shadow: 0 0 0 4px rgba(colors.$lightgrey-color, 0.4);
    }
  }

  &.selected {
    font-weight: 600;

    .switch {
      border-color: colors.$blue-color;
      background: rgba(colors.$blue-color, 0.15);

      &::after {
        background: colors.$blue-color;
        left: 2px;
      }
    }

    &:hover,
    &:focus {
      .switch {
        outline: none;
        box-shadow: 0 0 0 4px rgba(colors.$blue-color, 0.4);
      }
    }
  }
}

.radio-button {
  display: flex;
  align-items: center;
  margin-right: 40px;
  cursor: pointer;

  .radio {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: colors.$white-color;
    transition: 0.3s;
    cursor: pointer;
    margin-right: 10px;
    border: 1px solid colors.$lightgrey-color;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      width: 11px;
      height: 11px;
      border-radius: 50%;
      background: colors.$blue-color;
      opacity: 0;
      transition: 0.3s;
    }
  }

  &:hover {
    .radio:after {
      opacity: 0.8;
    }
  }

  &.selected {
    .radio:after {
      opacity: 1;
    }
    font-weight: 600;
  }
}

.checkbox-input {
  display: flex;
  align-items: center;
  width: 100%;
  margin-top: 24px;

  .checkbox {
    margin-right: 10px;
  }
}
</style>
